export type BookkeepingPlatform = (typeof allBookkeepingPlatforms)[number]

export const allBookkeepingPlatforms = ['Xero', 'QuickBooks', 'Other'] as const
